import React from 'react';
import { ClockIcon, CheckCircleIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
export function TrustBadges() {
  const badges = [{
    icon: ClockIcon,
    title: 'Aprobación en <48h',
    description: 'Respuesta rápida y proceso ágil'
  }, {
    icon: CheckCircleIcon,
    title: '100% Deducible',
    description: 'Reduce tu carga fiscal legalmente'
  }, {
    icon: TrendingUpIcon,
    title: '+20 años',
    description: 'Experiencia en financiamiento'
  }, {
    icon: ShieldCheckIcon,
    title: 'Sin enganche',
    description: 'Conserva tu liquidez operativa'
  }];
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-y border-slate-200" data-id="element-300">
      <div className="max-w-7xl mx-auto" data-id="element-301">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-302">
          {badges.map((badge, index) => <div key={index} className="text-center" data-id="element-303">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-primary-100 rounded-xl mb-4" data-id="element-304">
                <badge.icon className="w-6 h-6 text-primary-600" data-id="element-305" />
              </div>
              <h3 className="font-bold text-slate-900 mb-1" data-id="element-306">{badge.title}</h3>
              <p className="text-sm text-slate-600" data-id="element-307">{badge.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}